module.exports = require('./helpers/bundle-url').getBundleURL('76NkK') + "logo.7718c6df.svg";